<template>
  <button :class="btnClass"
          @click="onClickEvent">
    <slot name="fa-icon-before">
      <font-awesome-icon
        v-if="iconBeforeText"
        :icon="['fas', 'chevron-left']"
        aria-hidden="true"></font-awesome-icon>
    </slot>
    <span>
      <slot>Click me</slot>
    </span>
    <slot name="fa-icon-after">
      <font-awesome-icon
        v-if="!iconBeforeText"
        :icon="['fas', 'chevron-right']"
        aria-hidden="true"></font-awesome-icon>
    </slot>
  </button>
</template>
<script>
export default {
  name: "GlButton",
  props: {
    variant: {
      type: Number,
      default: 1,
    },
    href: {
      type: String,
      default: undefined,
    },
    iconBeforeText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnClass () {
      const result = ["gl-btn", "btn"];
      switch ( this.variant ) {
        case 1:
          result.push( "btn-accent-1" );
          break;
        case 2:
          result.push( "btn-accent-2" );
          break;
        case 3:
          result.push( "btn-accent-3" );
          break;
        default:
          break;
      }
      return result;
    },
  },
  methods: {
    onClickEvent () {
      if ( this.href ) {
        window.location.href = this.href;
      } else {
        this.$emit( "click" );
      }
    },
  },
};
</script>
<style lang="less" scoped>
.gl-btn {
  display: flex;
  align-items: center;

  > * + * {
    margin-left: 0.25rem;
  }
}
</style>
